<template>
    <div class="content container">

        <hr>
        <h2 class="text-center">
            Corona
        </h2>
        <hr>

        <div class="row">

            <div class="col-lg-12">

                <p>
                    Sehr geehrte Patientinnen und Patienten, zum Schutz der Kolleginnen und anderer Patienten/innen
                    halten Sie sich bitte an folgende Verhaltensregeln:
                </p>

                <p>Bei akuten Erkältungssymptomen (Fieber, Husten, Halsschmerzen, etc.), welche auf eine Covid-19
                    Infektion
                    schließen lassen, bitte ich Sie die Praxis nicht persönlich zu betreten. Bitte sagen Sie ihren
                    Therapietermin möglichst frühzeitig telefonisch ab bzw. können wir dann je nach Gesundheitszustand
                    auch
                    einen Termin zur Videosprechstunde vereinbaren. Hierzu wird ein von der Kassenärztlichen
                    Bundesvereinigung zertifizierter Anbieter genutzt. Sie benötigen dazu Bildschirm, Mikrofon, Kamera
                    und
                    einen stabilen Internetzugang.
                </p>
                <p>
                    Bitte tragen Sie in der Praxis einen Mund-Nase-Schutz.
                </p>

            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'ContentNews',
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .content {

    }
</style>
